import { LoadableAfterPaint } from '@confluence/loadable';
import type { SatisfactionSurveyModalProps } from '../src/SatisfactionSurveyModal.tsx';

export const SatisfactionSurveyModal = LoadableAfterPaint<SatisfactionSurveyModalProps>({
	loader: async () =>
		(
			await import(
				/* webpackChunkName: "loadable-SatisfactionSurveyModal" */ '../src/SatisfactionSurveyModal.tsx'
			)
		).SatisfactionSurveyModal,
});
